export default __webpack_public_path__ + "static/media/skull.a0dca06e.svg";